import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leftsnap",
  "use": "icon-leftsnap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-leftsnap\">\r\n     <path d=\"M153.6 102.4l51.2 0 0 819.2-51.2 0 0-819.2ZM256 204.8l409.6 0 0 256-409.6 0 0-256ZM819.2 563.2l0 204.8L307.2 768l0-204.8L819.2 563.2M870.4 512 256 512l0 307.2 614.4 0L870.4 512 870.4 512z\" p-id=\"2471\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol